// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_AtualizarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /plano_metas/atualizar/:id
 *
 * Validates monthly goal plan update requests. All fields are optional for
 * partial updates. If meta_faturamento or meta_clientes is provided,
 * ticket_medio_esperado is recalculated.
 */
import { registerContract } from './validate'

export interface PlanoMetas_AtualizarInput {
meta_faturamento?: number
meta_clientes?: number
}

registerContract('PlanoMetas_AtualizarInput', {
  meta_faturamento: { type: 'number',  required: false },
  meta_clientes:    { type: 'number',  required: false },
})
